import React from 'react';
import dynamic from 'next/dynamic';

import PageContainer from '../../js/components/PageContainer';
import Chat from '../../../server/services/ai/chat';

const ChatPage = dynamic(
  () => import('../../js/pages/ChatPage'),
  {ssr: false},
);

ChatPage.getLayout = (page) => <PageContainer hideFooter className="min-h-0">{page}</PageContainer>;

export async function getServerSideProps({req}) {
  let initialLimitReached = false;
  if (req.user) {
    try {
      const balance = await Chat.getChatBalance(req.user);
      initialLimitReached = balance <= 0;
    } catch (e) {
      initialLimitReached = false;
    }
  }
  return {props: {initialLimitReached}};
}

export default ChatPage;
